<script setup lang="ts">
import EditorsStaffPage from '@/pages/editorsStaff';
</script>

<template>
  <EditorsStaffPage />
</template>
